import Header from "@/components/Header";
import Footer from "@/components/Footer";
import VehicleGrid from "@/components/VehicleGrid";
import useSeo from "@/lib/useSeo";

export default function Veicoli() {
  useSeo({
    title: "Vendita Scooter Cabinati Elettrici e Auto Usate | Zibido San Giacomo (MI)",
    description:
      "Catalogo veicoli Minicarmobilità: scooter cabinati elettrici e benzina, auto usate certificate. Filtra per modello, motorizzazione e tipologia.",
  });
  return (
    <main data-testid="veicoli-page" className="min-h-screen bg-white">
      <Header />
      <div className="pt-32 pb-4 max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#5ab500] font-bold mb-3">
          — Catalogo completo
        </div>
        <h1 className="font-heading text-4xl md:text-6xl font-light tracking-tight text-[#1c1f1a]">
          I nostri <span className="italic text-[#5ab500]">veicoli</span>
        </h1>
        <p className="mt-4 text-[#7a7f77] max-w-2xl">
          Tutta la nostra disponibilità in vetrina. Filtra per categoria e clicca
          su un veicolo per scoprire tutti i dettagli.
        </p>
      </div>
      <VehicleGrid />
      <Footer />
    </main>
  );
}
